export const home="/home";
export const storesListing="/";
export const privacyPolicy="/privacy-policy";
export const regulations="/regulations";
export const contact="/contact";
export const blog="https://blog.szafapolska.pl";